export default "__VITE_ASSET__DBKubnTv__"